<template>
  <div class="pre-start-history" v-if="machine">

    <h1 class="title is-4 pad no-margin">{{ title }}</h1>

    <b-modal :active.sync="showModal">
      <div class="box" v-if="selected">
        <a class="delete" @click="showModal = false"></a>
        <h1 class="title is-4">Pre-Start Check</h1>
        <div class="columns">
          <div class="column bold">
            {{ selected.timestampStarted | unixToDateTimeString }}
          </div>
          <div class="column bold">
            {{ selected.user }}
          </div>
        </div>
        <div class="columns" v-if="selected.address">
          <div class="column">
            <p>{{ selected.address }}</p>
            <em class="has-text-grey-light">(Approximate geolocated address)</em>
            <p v-if="selected.coord">{{ selected.coord | prettyCoord }} </p>
          </div>
        </div>
        <check-list-summary :check-list="selected" />
      </div>
    </b-modal>

    <template v-if="checkLists === null">
      <loading />
    </template>

    <template v-else-if="checkLists">
      <div class="pad-left">
        Showing {{ morePreStartChecks ? `latest ${limit}` : 'all' }}
      </div>
      <table class="table is-hoverable is-striped">
        <tbody>
          <tr v-for="checkList in checkLists" :key="checkList._id" @click="selected = checkList">
            <td class="bold">{{ checkList.timestampStarted | unixToDateString }}</td>
            <td>{{ checkList.user }}</td>
            <td>{{ checkList.checks[0].value }} {{ machine.units }}</td>
          </tr>
        </tbody>
      </table>
    </template>

  </div>
</template>

<script>
import CheckListSummary from '@/components/CheckListSummary'
export default {
  name: 'PreStartHistory',
  props: {
    title: { default: 'Pre-Start Checks' },
    machine: { default: null },
    limit: { default: 50 }
  },
  components: {
    CheckListSummary
  },
  data () {
    return {
      checkLists: null,
      selected: null,
      moreChecks: false,
      showModal: false
    }
  },
  watch: {
    machine () { this.getCheckLists() },
    limit () { this.getCheckLists() },
    selected () {
      if (this.selected) {
        this.showModal = true
      }
    },
    showModal () {
      if (!this.showModal) {
        this.selected = null
      }
    }
  },
  created () {
    this.getCheckLists()
  },
  methods: {
    getCheckLists () {
      this.checkLists = null

      this.unsub('preStartChecks')
      if (!this.machine) {
        return
      }

      this.subs.preStartChecks = this.snapshotUnsiubscribe = this.$firestore.collection('preStartChecks')
        .where('machineId', '==', this.machine._id)
        .orderBy('timestampStarted', 'desc')
        .limit(this.limit + 1)
        .onSnapshot(snapshot => {
          let checkLists = this.$utils.snapshotToArr(snapshot)
          this.morePreStartChecks = checkLists.length > this.limit
          if (this.moreChecks) {
            checkLists.pop()
          }
          this.checkLists = checkLists
        })
    }
  }
}
</script>

<style>
  .pre-start-history .modal .box .column  {
    padding: 2px;
  }

  .pre-start-history  table {
    border-top: solid 2px #ccc;
  }
</style>
